import React from 'react';
import DocumentHeaderButton from 'Components/DocumentHeaderButton';

import ScaleDropDown from './ScaleDropDown';

import CopyIcon from 'Assets/images/icons/copy-icon.svg';
import PasteIcon from 'Assets/images/icons/paste-icon.svg';

interface ModalHeaderActionButtonsProps {
  documentScale: number;
  onScaleChange: (value: number) => void;
  onCopy?: () => void;
  onPaste?: () => void;
}

const ModalHeaderActionButtons = ({
  documentScale,
  onScaleChange,
  onCopy,
  onPaste,
}: ModalHeaderActionButtonsProps) => (
  <div className="interactModal__header-copyPast">
    <DocumentHeaderButton onClick={onCopy} icon={CopyIcon}>
      <span className="interactModal__header-bar-button-text">Copy</span>
    </DocumentHeaderButton>
    <DocumentHeaderButton onClick={onPaste} icon={PasteIcon}>
      <span className="interactModal__header-bar-button-text">Paste</span>
    </DocumentHeaderButton>
    <ScaleDropDown
      changeScale={onScaleChange}
      documentScale={documentScale}
      rootClassName="interactModal__header-scale"
      toggleClassName="interactModal__header-scale-toggle"
    />
  </div>
);

export default ModalHeaderActionButtons;
